export default "__VITE_ASSET__CxlNBoEW__"